import React, { useState, useEffect } from 'react';

import '../../../App.css'
import { parseISO, differenceInWeeks } from 'date-fns';

const ImageGallery = ({ initialImages, styleFunction = () => {}, isEditMode = false, setUploadImages }, model, setModel) => {
    const [currentImage, setCurrentImage] = useState(initialImages[0]?.file || '/path/to/fallback/image.jpg');
    const [images, setImages] = useState(initialImages || []);

    useEffect(() => {
        if (initialImages && initialImages.length > 0) {
            setImages(images || initialImages);
            setCurrentImage(currentImage || initialImages[0].file);
        }
        images.forEach((img) => URL.revokeObjectURL(img.file.path));
    }, [initialImages, currentImage]);

    //console.log('images: ', images);

    const handleImageClick = (image) => {
        setCurrentImage(image);
    };

    if (!images || images.length === 0) {
        return <div>No images available</div>;
    }

    const handleAddImage = (event) => {
        const files = Array.from(event.target.files); // Convert FileList to an array
        const newImages = files.map((file) => ({
            file: URL.createObjectURL(file), // Temporary URL for preview
            timestamp: new Date().toISOString(), // Current timestamp in ISO format
        }));
        setImages((prevImages) => {
            const updatedImages = [...prevImages, ...newImages];
            console.log('Updated Images State:', updatedImages); // Inspect the state
            return updatedImages;
        });

        const newUploadImages = files.map((file) => ({
            file: {
                name: file.name,
                path: `uploads/${file.name}`,
                mimetype: file.type,
            },
            timestamp: new Date().toISOString(),
        }));

        setUploadImages((prevImages) => {
            const updatedImages = [...prevImages, ...newUploadImages];
            console.log('Updated Images State:', updatedImages); // Inspect the state
            return updatedImages;
        });
    };

    return (
        <div className="gallery">
            <div className="main-image">
                <img src={currentImage} alt="Main" />
            </div>
            <div className="image-grid">
                {isEditMode && (
                    <label className="add-image" data-tooltip="Click to add an image">
                        <span className="plus-sign">+</span>
                        <input
                            type="file"
                            multiple
                            accept="image/*"
                            style={{ display: "none" }} // Hide the actual input
                            onChange={handleAddImage} // Attach the handler here
                        />
                    </label>
                )}
                {images.map((image, index) => (
                    <div key={index} className="image-item">
                        <img
                            src={image.file}
                            alt={`Image ${index + 1}`}
                            onClick={() => handleImageClick(image.file)}
                            className={image.file === currentImage ? 'active' : ''}
                            style={{ border: styleFunction(image.timestamp) || '3px solid gray'}}
                        />
                    </div>
                ))}
            </div>
        </div >
    );
};

export default ImageGallery;